export var KpiOperation;
(function (KpiOperation) {
    KpiOperation["INITIATE_AUTHENTICATION"] = "INITIATE_AUTHENTICATION";
    KpiOperation["INITIATE_FIDO_REGISTRATION"] = "INITIATE_FIDO_REGISTRATION";
    KpiOperation["PROVIDE_AUTHENTICATION_CHALLENGE"] = "PROVIDE_AUTHENTICATION_CHALLENGE";
    KpiOperation["COMPLETE_AUTHENTICATION"] = "COMPLETE_AUTHENTICATION";
    KpiOperation["COMPLETE_FIDO_REGISTRATION"] = "COMPLETE_FIDO_REGISTRATION";
    KpiOperation["LOOKUP_AUTHENTICATION_METHODS"] = "LOOKUP_AUTHENTICATION_METHODS";
})(KpiOperation || (KpiOperation = {}));
